import type { SVGProps } from 'react';

const SvgMarketingResources = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" {...props}>
    <path
      fill={props.color}
      fillRule="evenodd"
      d="M3 3.563h5.333v4H3zm1.333 1.333V6.23H7V4.896z"
      clipRule="evenodd"
    />
    <path fill={props.color} d="M3 10.23h5.333V8.896H3z" />
    <path
      fill={props.color}
      fillRule="evenodd"
      d="M2.333 13.563a2 2 0 0 1-2-2V2.896a2 2 0 0 1 2-2H9a2 2 0 0 1 2 2h.666a2 2 0 0 1 2 2v6.667a2 2 0 0 1-2 2zM1.666 2.896c0-.368.299-.666.667-.666H9c.368 0 .666.298.666.666v9.334H2.333a.667.667 0 0 1-.667-.667zM11 12.23h.666a.667.667 0 0 0 .667-.667V4.896a.667.667 0 0 0-.667-.666H11z"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgMarketingResources;
